/**
 * AppTopBar — Standard top bar for OpCentral apps.
 * Uses CSS variables from @opcentral/skinnr-lib/theme/opcentral.css
 */

import React from 'react';

export interface AppTopBarProps {
  appName: string;
  logo?: string;
  showNavToggle?: boolean;
  onToggleNav?: () => void;
  actions?: React.ReactNode;
}

export function AppTopBar({
  appName,
  logo,
  showNavToggle = false,
  onToggleNav,
  actions,
}: AppTopBarProps) {
  return (
    <header className="oc-topbar">
      <div className="oc-topbar-left">
        {showNavToggle && (
          <button className="oc-topbar-btn" onClick={onToggleNav} aria-label="Toggle navigation">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        )}
        {logo && (
          <span className="oc-topbar-logo">
            {logo.startsWith('http') || logo.startsWith('/') ? (
              <img src={logo} alt={appName} height="24" />
            ) : (
              logo
            )}
          </span>
        )}
        <span className="oc-topbar-title">{appName}</span>
      </div>

      {actions && <div className="oc-topbar-right">{actions}</div>}
    </header>
  );
}
